import { render, staticRenderFns } from "./AlbumDynamicTopMatter.vue?vue&type=template&id=066c9def&scoped=true"
import script from "./AlbumDynamicTopMatter.vue?vue&type=script&lang=ts"
export * from "./AlbumDynamicTopMatter.vue?vue&type=script&lang=ts"
import style0 from "./AlbumDynamicTopMatter.vue?vue&type=style&index=0&id=066c9def&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066c9def",
  null
  
)

export default component.exports